import { ONE_SECOND_IN_MS } from '~/constants'

const ACCESS_TOKEN_EXPIRY_SKEW_MS = 30 * ONE_SECOND_IN_MS

const AUTH_SESSION_QUERY_KEY = 'authSession'

export const authSessionQueryKey = () => [AUTH_SESSION_QUERY_KEY]

export const isAccessTokenExpiringSoon = (expiresAt?: number) => {
  if (!expiresAt) return true

  return expiresAt * 1000 - ACCESS_TOKEN_EXPIRY_SKEW_MS <= Date.now()
}
